import React from "react";

const StudentHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#dashboard">1. Dashboard</a>
            <a href="#resources">2. Resources</a>
            <a href="#courses">3. Courses </a>
            <a href="#grades">4. Grades </a>
            <a href="#accounts">5. Student Accounts</a>
            <a href="#academic-profile">6. Academic Profile</a>
            <a href="#career-path">7. Career Path</a>
            <a href="#notifications">8. Notifications</a>
            <a href="#feedback">9. Feedback</a>
            <a href="#settings">10. Settings</a>
            <a href="#navbar">11. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows Student/Freshman users to securely sign
                in. Follow these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="dashboard" className="section">
              <h2>1. Student Dashboard</h2>
              <p>Navigate to dashboard screen</p>
              <h3>1.1 Student Metrics</h3>
              <ul>
                <li>Academic Profile</li>
                <p>
                  A visual overview of your academic progress. View your program
                  name, GPA, percentage of academic progress, total credits, and
                  completed courses at a glance.
                </p>
                <li>Course Details</li>
                <p>
                  Current semester course information. Check how many courses
                  you are taking, their combined credits, and your overall
                  course completion status.
                </p>
                <li>Student Account</li>
                <p>
                  A financial chart displaying your term-wise account balance.
                  Review the trend of your future net balance and current term
                  balance to understand your financial obligations and aid.
                </p>
                <li>Grade Details</li>
                <p>
                  A pie chart breakdown of your grade distribution for the term.
                  Analyze the percentage of each grade received (e.g., A, B, C)
                  to assess academic strengths and weaknesses.
                </p>
              </ul>

              <h3>1.2 Student Apps</h3>
              <ul>
                <li>The available student Apps are displayed in this block</li>
                <li>Click any app to redirect its corresponding URL</li>
                <li>
                  Click the View All button and you will be redirected to the
                  Student Resource page.
                </li>
              </ul>

              <h3>1.3 Student Resources</h3>
              <ul>
                <li>
                  The available student's resources are displayed in this block
                </li>
                <li>Click any app to redirect its corresponding URL</li>
                <li>
                  Click the View All button and you will be redirected to the
                  Student Resource page.
                </li>
              </ul>

              <h3>1.4 Calendar</h3>
              <ul>
                <li>Navigate to the calendar view.</li>
                <li>
                  By default, the current month is displayed, and the current
                  date is highlighted.
                </li>
                <li>
                  If any events are set for the selected day, a popup will
                  display the list of scheduled events.
                </li>
                <li>
                  The message "No events scheduled for this day" will appear if
                  there are no events. This indicates that no meetings, tasks,
                  or activities are planned for the selected date.
                </li>
              </ul>
            </div>

            <div id="resources" className="section">
              <h2>2. Resources</h2>
              <h3>2.1 Student Resource</h3>
              <ul>
                <li>Navigate to the Resources page.</li>
                <li>Click on the Student Resource widget.</li>
                <li>
                  When you click on each widget, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the View Details button to be redirected to
                  corresponding URL
                </li>
              </ul>

              <h3>2.2 Student Apps</h3>
              <ul>
                <li>Navigate to the Resources page.</li>
                <li>Click on the Student Apps</li>
                <li>
                  When you click on each app, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the access app button to be redirected to
                  corresponding URL
                </li>
              </ul>
            </div>

            <div id="courses" className="section">
              <h2>3. Courses</h2>
              <h3>3.1 Courses</h3>
              <ul>
                <li>Navigate to the course page.</li>
                <li>Click on the subject under each fall</li>
                <li>
                  By default, current term subjects are displayed of that
                  student
                </li>
                <li>
                  When you click on each subject, the respective details like
                  class, instructor, credit, and description are displayed.
                </li>
                <li>
                  Click on the access your course Button to be redirected to
                  university page
                </li>
                <li>
                  Click on the course button and a popup will appear and provide
                  your rating.
                </li>
                <li>Click Submit button</li>
                <li>Click Cancel to exit the popup window</li>
              </ul>

              <h3>3.2 Quick Links</h3>
              <ul>
                <li>
                  The Quick Links block displays essential student links for
                  easy access.
                </li>
                <li>
                  Click on any quick link to be redirected to its respective
                  URL.
                </li>
                <li>
                  Click on View All to see the complete list of quick links.
                </li>
              </ul>

              <h3>3.3 Need Help? Contact Us</h3>
              <ul>
                <li>
                  Use this section to quickly connect with support contacts.
                </li>
                <li>
                  A message will appear:
                  <ul>
                    <li>
                      {" "}
                      "I can help you reach your contacts. Select who you want
                      and click 'Connect.'
                    </li>
                  </ul>
                </li>
                <li>
                  Click on "Select Contacts" to view available support contacts.
                </li>
                <li>
                  Choose a contact and click "Connect" a mail compose popup will
                  appear{" "}
                </li>
                <li>
                  Choose the recipient email id contacts and enter the subjects
                  and message to send the mail
                </li>
              </ul>

              <h3>3.4 Calendar</h3>
              <ul>
                <li>Navigate to the Calendar module.</li>
                <li>
                  By default current week will be displayed and current date is
                  highlighted and events for that day will be displayed
                </li>
                <li>
                  A list of scheduled events will appear for the selected day if
                  configured any event
                </li>
                <li>
                  The message "No events scheduled for this day" will appear if
                  there are no events. This indicates that no meetings, tasks,
                  or activities are planned for the selected date.
                </li>
                <li>
                  By clicking on view entire schedule button,will be redirected
                  to the google calender of the user
                </li>
                <li>By clicking on the arrow can change the week</li>
              </ul>
            </div>

            <div id="grades" className="section">
              <h2>4. Grades</h2>
              <h3>4.1 Grades</h3>
              <ul>
                <li>Navigate to the Grades page from the main menu.</li>
                <li>
                  By default, Current term and grade details will be displayed
                </li>
                <li>
                  The page displays a list of course Name and Grade for each.
                </li>
                <li>
                  Click the "View All" button. You will be redirected to the
                  university's page.
                </li>
              </ul>

              <h3>4.2 Grade Distribution</h3>
              <ul>
                <li>Navigate to the Grades page.</li>
                <li>
                  A pie chart is displayed, showing the distribution of grades
                  with their respective percentages.
                </li>
                <li>
                  This helps visualize overall performance across different
                  grade categories.
                </li>
                <li>
                  Click on the Zoom In button. The grade chart or data will
                  enlarge for better visibility and more detailed view.
                </li>
                <li>
                  By hovering over the pie chart, legends and percentage will be
                  highlighted
                </li>
              </ul>

              <h3>4.3 Plan Your Next Term</h3>
              <ul>
                <li>
                  Helps you prepare and organize for a successful upcoming term
                </li>
                <li>
                  Configured items related to planning are listed on this block
                </li>
                <li>
                  Click any item which is redirected to its corresponding URL
                </li>
                <li>
                  Click the View All button, you will be redirected to the All
                  Plan your next term page.
                </li>
              </ul>

              <h3>4.4 Early Alerts</h3>
              <ul>
                <li>
                  It normally gives academic alerts regarding the student
                  performance / GPA, Failures for Students{" "}
                </li>
                <li>
                  Click the View All button. You will be redirected to
                  university page{" "}
                </li>
              </ul>

              <h3>4.5 Course Details</h3>
              <ul>
                <li>Course details for the current term</li>
                <li>Navigate to the Course Details section.</li>
                <li>The diagram displays the following information:</li>
                <li>Overall Progress shown in percentage</li>
                <li>Semester information</li>
                <li>Course Name</li>
                <li>Total Credits assigned to the course</li>
                <li>This visual helps track academic progress at a glance.</li>
              </ul>

              <h3>4.6 Need Help? Contact Us</h3>
              <ul>
                <li>
                  Use this section to quickly connect with support contacts.
                </li>
                <li>
                  A message will appear:
                  <ul>
                    <li>
                      "I can help you reach your contacts. Select who you want
                      and click 'Connect'."
                    </li>
                  </ul>
                </li>
                <li>
                  Click on "Select Contacts" to view available support contacts.
                </li>
                <li>
                  Choose a contact and click "Connect" a mail compose popup will
                  appear{" "}
                </li>
                <li>
                  Choose the recipient email id contacts and enter the subjects
                  , message and click send button.
                </li>
              </ul>
            </div>

            <div id="accounts" className="section">
              <h2>5. Student Accounts</h2>
              <h3>5.1 Student Accounts</h3>
              <ul>
                <li>Navigate to the Student accounts </li>
                <li>The following information is displayed:</li>
                <li>
                  Billable Credit Hours: Shows the number of credit hours billed
                  (e.g., 04).
                </li>
                <li>
                  Future Net Balance: Displays the expected future balance
                  (e.g., $200).
                </li>
                <li>
                  Current Term Balance: Indicates the outstanding balance for
                  the current term (e.g., $182).
                </li>
                <li>
                  Cafeteria Balance: Shows the available cafeteria funds (e.g.,
                  $40).
                </li>
                <li>
                  Review these balances regularly to stay updated on your
                  account status.
                </li>
              </ul>

              <h3>5.2 Account Resources</h3>
              <ul>
                <li>Configured items are listed on the Account Resources</li>
                <li>
                  Click any item to open its corresponding url in a new tab.
                </li>
                <li>
                  Click the View All button. You will be redirected to the
                  All-resource page.
                </li>
              </ul>

              <h3>5.3 Transactions</h3>
              <ul>
                <li>Navigate to the transactions</li>
                <li>
                  Transactions are listed with their respective categories and
                  amounts
                </li>
                <li>
                  Click view all button.You will be redirected to the university
                  page.
                </li>
              </ul>

              <h3>5.4 Scholarship</h3>
              <ul>
                <li>Navigate to the Scholarship section</li>
                <li>
                  Click on the "More Details" button which is redirected to the
                  university page for more scholarship details
                </li>
              </ul>

              <h3>5.5 Financial Assistance</h3>
              <ul>
                <li>Navigate to the Financial Assistance section</li>
                <li>
                  Students can connect with the Financial Assistance team via
                  email.
                </li>
                <li>
                  In the popup, students can compose and send an email directly
                  to the Financial Assistance team.
                </li>
              </ul>
            </div>

            <div id="academic-profile" className="section">
              <h2>6. Academic Profile</h2>
              <h3>6.1 Academic Profile</h3>
              <ul>
                <li>Navigate to the Academic Profile section</li>
                <li>
                  The following academic summary of the student will be
                  displayed:
                  <ul>
                    <li>Grade Point Average (GPA)</li>
                    <li>Academic Progress</li>
                    <li>Completed Courses</li>
                    <li>Total Credits: </li>
                  </ul>
                </li>
                <li>
                  This section helps you monitor your academic performance and
                  credit completion.
                </li>
                <li>
                  Click on View details/Update. You will be redirected to the
                  university's page.
                </li>
                <li>
                  Navigate to the Academic Details section.
                  <ul>
                    <li>
                      The Student Level, Division, and Campus of the student
                      will be displayed.
                    </li>
                    <li>
                      This section provides a summary of the student’s academic
                      classification and campus location.
                    </li>
                  </ul>
                </li>
                <li>
                  Navigate to the Program
                  <ul>
                    <li>
                      Student can view academic details like Program of Study,
                      Major, Minor, and Certificates.
                    </li>
                  </ul>
                </li>
                <li>
                  Student Status
                  <ul>
                    <li>
                      Students can view details such as Admissions,
                      International Student status, Enrollment, Holds, Academic,
                      and Financial Clearance.
                    </li>
                  </ul>
                </li>
              </ul>

              <h3>6.2 Need Help? Contact Us</h3>
              <ul>
                <li>
                  Use this section to quickly connect with support contacts.
                </li>
                <li>
                  A message will appear:
                  <ul>
                    <li>
                      "I can help you reach your contacts. Select who you want
                      and click 'Connect'."
                    </li>
                  </ul>
                </li>
                <li>
                  Click on "Select Contacts" to view available support contacts.
                </li>
                <li>
                  Choose a contact and click "Connect" to initiate
                  communication.
                </li>
              </ul>

              <h3>6.3 Your Degree Progress & Early Alerts</h3>
              <ul>
                <li>
                  Click on these will be redirected to corresponding URL with
                  respect to the degree progress and Early alert page.
                </li>
              </ul>

              <h3>6.4 Course Details </h3>
              <ul>
                <li>Course details for the current term</li>
                <li>
                  The diagram displays the following information:
                  <ul>
                    <li>The diagram displays the following information:</li>
                    <li>Semester information</li>
                    <li>Course Name</li>
                    <li>Total Credits assigned to the course</li>
                  </ul>
                </li>
                <li>This visual helps track academic progress at a glance.</li>
              </ul>
            </div>

            <div id="career-path" className="section">
              <h2>7. Career Path</h2>
              <ul>
                <li>
                  The Career Path section helps students explore job
                  opportunities related to their program of study.
                </li>
                <li>
                  Displays an image with a brief description about career
                  guidance.
                </li>
                <li>
                  Current Openings
                  <ul>
                    <li>
                      Shows job listings based on the student’s program of
                      study.
                    </li>
                    <li>
                      Each job includes a Job Title and a short Description.
                    </li>
                    <li>
                      Click More Details to be redirected to the official O*NET
                      page for complete job information.
                    </li>
                  </ul>
                </li>
                <li>
                  Search Bar
                  <ul>
                    <li>
                      Enter keywords (e.g., Computer Science) in the search bar.
                    </li>
                    <li>
                      Press Enter or click the Search icon to view relevant job
                      openings..
                    </li>
                  </ul>
                </li>
              </ul>
            </div>

            <div id="notifications" className="section">
              <h2>8. Notifications</h2>
              <ul>
                <li>
                  Navigate to the Notifications section to view all
                  notifications.
                </li>
                <li>
                  Notifications are listed with details including:
                  <ul>
                    <li>Category (e.g., Campus Safety, Management)</li>
                    <li>Date (e.g., 29 days ago)</li>
                    <li>Status (e.g., New)</li>
                  </ul>
                </li>
                <li>By default, all notifications will be displayed.</li>
                <li>
                  To filter, click the “Select Notification Type” dropdown and
                  choose a category such as Announcement, Management, Exam
                  Announcement, or Campus Safety. Only notifications of the
                  selected type will be shown.
                </li>
              </ul>
            </div>

            <div id="feedback" className="section">
              <h2>9. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>9.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img src="assets/images/help/feedback.png" alt="Feedback" />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>9.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>
            </div>

            <div id="settings" className="section">
              <h2>10. Settings</h2>
              <h3>10.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/student_editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
              <h3>10.2 Visibility & Priority Settings of Apps and Widgets</h3>
              <p>
                This section allows users to customize the visibility and
                display order of apps and widgets in their portal.
              </p>
              <ul>
                <li>
                  In the Settings Page, all apps and widgets are listed along
                  with their current visibility and order.
                </li>
                <li>
                  Change Visibility: To hide an app or widget, uncheck the radio
                  button next to its name.
                </li>
                <li>
                  Change Display Order: Rearrange the apps and widgets by
                  dragging and dropping them into the desired order.
                </li>
              </ul>
            </div>

            <div id="navbar" className="section">
              <h2>11. Navigation Bar</h2>
              <ul>
                <li>
                  <p>
                    The BUDU Portal provides an AI-based Search that helps users
                    quickly find information. As you type, the system shows
                    helpful suggestions based on your past searches and
                    available data. If you enter a question, the AI chatbot will
                    open and provide answers. This makes it easy to locate what
                    you need and ensuring a smooth and efficient search
                    experience for all users.
                  </p>
                </li>
                <li>
                  Email Icon: Click on, redirect to the Mail Compose Page. Users
                  can Choose contacts, Compose and send an email
                </li>
                <li>
                  Safety Alert Icon: On click, displays the latest early alerts
                  with details.
                  <ul>
                    <li>
                      Contact Team: Opens the Mail Compose Page pre-filled to
                      contact the safety team.
                    </li>
                    <li>
                      View More: Redirects to the University Campus Safety Alert
                      Page for additional information.
                    </li>
                  </ul>
                </li>
                <li>Notification Icon: Redirects to the Notifications Page.</li>
                <li>
                  Profile Icon: Once the Logout button is clicked, you will be
                  logged out and redirected to the login page.{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StudentHelpInstructions;
